module.exports = __webpack_public_path__ + "img/foto-flavio-baiocchi.jpg";